__turbopack_context__.v({
  "triggers": "OverlayDeck-module__L6QQ1q__triggers",
});
